import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data/content";
import { StarDash } from "@/components/StarDash";

const TestimonialCard = ({ t }) => (
  <div
    className="shrink-0 w-[300px] sm:w-[420px] mr-4 sm:mr-6 p-6 sm:p-8 bg-[#fbf3e6] border border-[#d9c9b2] relative"
    data-testid={`testimonial-${t.name.replace(/\s+/g, "-").toLowerCase()}`}
  >
    <div className="absolute inset-2 pointer-events-none border border-[#c63027]/20" />
    <div className="relative">
      <div className="flex items-center justify-between">
        <div className="flex gap-1">
          {[...Array(5)].map((_, i) => (
            <Star key={i} className="size-4 fill-[#c63027] text-[#c63027]" />
          ))}
        </div>
        <Quote className="size-7 text-[#c63027]/30" />
      </div>
      <p className="font-italic-serif mt-5 text-xl text-[#2b1a14] leading-snug">
        "{t.quote}"
      </p>
      <div className="mt-6 pt-5 border-t border-[#c63027]/20">
        <div className="font-display font-bold text-base text-[#c63027]">
          {t.name}
        </div>
        <div className="font-sans-body text-[10px] uppercase tracking-[0.22em] text-[#6b5a4a] mt-1">
          ★ {t.role}
        </div>
      </div>
    </div>
  </div>
);

const Testimonials = () => {
  const items = [...TESTIMONIALS, ...TESTIMONIALS];
  return (
    <section
      id="reviews"
      data-testid="testimonials-section"
      className="py-20 sm:py-32 bg-[#f5ede1]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10 text-center">
        <div className="reveal">
          <StarDash />
          <div className="mt-6 font-sans-body text-[11px] font-bold uppercase tracking-[0.32em] text-[#6b5a4a]">
            ★ Word on the street
          </div>
          <h2 className="font-display mt-4 text-4xl sm:text-6xl lg:text-7xl font-bold tracking-tight text-[#2b1a14]">
            Clients who keep
            <br />
            <span className="font-italic-serif text-[#c63027]">coming back.</span>
          </h2>
        </div>
      </div>

      <div className="mt-14 overflow-hidden">
        <div className="marquee-track flex w-max">
          {items.map((t, i) => (
            <TestimonialCard key={i} t={t} />
          ))}
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-6 mt-10 text-center">
        <div className="inline-flex items-center gap-4 text-sm text-[#6b5a4a]">
          <div className="flex gap-1">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="size-4 fill-[#c63027] text-[#c63027]" />
            ))}
          </div>
          <span className="font-italic-serif text-lg">
            Trusted by hundreds of KL homeowners, landlords and offices.
          </span>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
